import * as React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import Popup, { FooterData } from '../../Popup';
import { PopupBody } from './styles';
import { signOut } from '../../../containers/MultiAppAuthentication/actions';

interface AnotherUserLoginPopupProps {
	isDisplayed: boolean;
	dispatch: Dispatch<StoreState>;
}

const AnotherUserLoginPopup = ({ isDisplayed, dispatch }: AnotherUserLoginPopupProps) => {
	const popupFooter: FooterData = {
		label: I18n.t('messages.back_to_login'),
		onAccept: () => dispatch(signOut()),
	};

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.notification')}
			footer={popupFooter}
		>
			<PopupBody>
				<Translate value="error.another_user_login" />
			</PopupBody>
		</Popup >
	);
};

export default AnotherUserLoginPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/AnotherUserLoginPopup/index.tsx